// components/WithPermission.js
export default function WithPermission({ permission, rights, children }) {
    return rights.includes(permission) ? children : null;
}
  